// Kansas State University's bachelor's majors (#2739). Read on 2026-10-01
// from K-State's official Majors and Programs finder
// (k-state.edu/academics/majors-programs), rendered in a browser: every
// program card typed "Bachelor's" and pinned to the Manhattan campus.
// Minors, certificates, dual and accelerated bachelor's/master's programs,
// graduate degrees, the Exploratory Tracks (not a major) and Salina-only or
// online-only programs are left out. The finder gives no degree type and no
// college, so this is one A to Z group with no degree. The K-State catalog
// was not readable (it answers 403 to automated reads).
const majors = {
    "slug": "kansas-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's major on K-State's Manhattan campus, from its official majors and programs finder. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Bachelor's majors, Manhattan campus",
            "source": {
                "label": "K-State, Majors and Programs",
                "url": "https://www.k-state.edu/academics/majors-programs/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": null
                },
                {
                    "name": "Addiction Counseling",
                    "degree": null
                },
                {
                    "name": "Advertising and Public Relations",
                    "degree": null
                },
                {
                    "name": "Agribusiness",
                    "degree": null
                },
                {
                    "name": "Agricultural Economics",
                    "degree": null
                },
                {
                    "name": "Agricultural Education",
                    "degree": null
                },
                {
                    "name": "Agricultural and Natural Resources Communications",
                    "degree": null
                },
                {
                    "name": "Agronomy",
                    "degree": null
                },
                {
                    "name": "Animal Sciences and Industry",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Architectural Engineering",
                    "degree": null
                },
                {
                    "name": "Art",
                    "degree": null
                },
                {
                    "name": "Art History",
                    "degree": null
                },
                {
                    "name": "Athletic Training and Rehabilitation Sciences",
                    "degree": null
                },
                {
                    "name": "Aviation Management",
                    "degree": null
                },
                {
                    "name": "Bakery Science and Management",
                    "degree": null
                },
                {
                    "name": "Biochemistry",
                    "degree": null
                },
                {
                    "name": "Biological Systems Engineering",
                    "degree": null
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": null
                },
                {
                    "name": "Chemical Engineering",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Civil Engineering",
                    "degree": null
                },
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": null
                },
                {
                    "name": "Communication Studies",
                    "degree": null
                },
                {
                    "name": "Computer Engineering",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Construction Science and Management",
                    "degree": null
                },
                {
                    "name": "Criminology",
                    "degree": null
                },
                {
                    "name": "Cybersecurity",
                    "degree": null
                },
                {
                    "name": "Dietetics",
                    "degree": null
                },
                {
                    "name": "Digital Innovation in Media",
                    "degree": null
                },
                {
                    "name": "Diversified Agriculture",
                    "degree": null
                },
                {
                    "name": "Early Childhood Education",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Educational Studies",
                    "degree": null
                },
                {
                    "name": "Electrical Engineering",
                    "degree": null
                },
                {
                    "name": "Elementary Education",
                    "degree": null
                },
                {
                    "name": "Engineering Technology Management",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Entomology",
                    "degree": null
                },
                {
                    "name": "Entrepreneurship",
                    "degree": null
                },
                {
                    "name": "Entrepreneurship and Innovation",
                    "degree": null
                },
                {
                    "name": "Environmental Engineering",
                    "degree": null
                },
                {
                    "name": "Environmental Science",
                    "degree": null
                },
                {
                    "name": "Family and Consumer Sciences Education",
                    "degree": null
                },
                {
                    "name": "Fashion Studies",
                    "degree": null
                },
                {
                    "name": "Feed and Pet Food Science",
                    "degree": null
                },
                {
                    "name": "Finance",
                    "degree": null
                },
                {
                    "name": "Fisheries, Wildlife, Conservation, and Environmental Biology",
                    "degree": null
                },
                {
                    "name": "Food Science and Industry",
                    "degree": null
                },
                {
                    "name": "General Agriculture",
                    "degree": null
                },
                {
                    "name": "Geographic Information Science and Technology",
                    "degree": null
                },
                {
                    "name": "Geography",
                    "degree": null
                },
                {
                    "name": "Geology",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Horticulture",
                    "degree": null
                },
                {
                    "name": "Hospitality Management",
                    "degree": null
                },
                {
                    "name": "Human Development and Family Science",
                    "degree": null
                },
                {
                    "name": "Humanities",
                    "degree": null
                },
                {
                    "name": "Industrial Engineering",
                    "degree": null
                },
                {
                    "name": "Integrated Computer Science",
                    "degree": null
                },
                {
                    "name": "Integrative Human Sciences",
                    "degree": null
                },
                {
                    "name": "Integrative Physiology",
                    "degree": null
                },
                {
                    "name": "Interior Design",
                    "degree": null
                },
                {
                    "name": "Kinesiology",
                    "degree": null
                },
                {
                    "name": "Life Science",
                    "degree": null
                },
                {
                    "name": "Management",
                    "degree": null
                },
                {
                    "name": "Management Information Systems",
                    "degree": null
                },
                {
                    "name": "Marketing",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": null
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": null
                },
                {
                    "name": "Microbiology",
                    "degree": null
                },
                {
                    "name": "Milling Science and Management",
                    "degree": null
                },
                {
                    "name": "Modern Languages - French",
                    "degree": null
                },
                {
                    "name": "Modern Languages - German",
                    "degree": null
                },
                {
                    "name": "Modern Languages - Spanish",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Music Education",
                    "degree": null
                },
                {
                    "name": "News and Sports Media",
                    "degree": null
                },
                {
                    "name": "Nuclear Engineering",
                    "degree": null
                },
                {
                    "name": "Nutrition and Health",
                    "degree": null
                },
                {
                    "name": "Nutritional Sciences",
                    "degree": null
                },
                {
                    "name": "Operations and Supply Chain Management",
                    "degree": null
                },
                {
                    "name": "Park Management and Conservation",
                    "degree": null
                },
                {
                    "name": "Personal Financial Planning",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physical Science",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Professional Strategic Selling",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Public Health",
                    "degree": null
                },
                {
                    "name": "Real Estate and Community Development",
                    "degree": null
                },
                {
                    "name": "Secondary Education",
                    "degree": null
                },
                {
                    "name": "Social Science",
                    "degree": null
                },
                {
                    "name": "Social Transformation Studies",
                    "degree": null
                },
                {
                    "name": "Social Work",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Sports Nutrition",
                    "degree": null
                },
                {
                    "name": "Statistics and Data Science",
                    "degree": null
                },
                {
                    "name": "Strategic Management",
                    "degree": null
                },
                {
                    "name": "Studio Art",
                    "degree": null
                },
                {
                    "name": "Theatre",
                    "degree": null
                },
                {
                    "name": "Visual Communication Design",
                    "degree": null
                },
                {
                    "name": "Wildlife and Outdoor Enterprise Management",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
